import {
  ERROR_PATH,
  FORBIDDEN_PATH,
  RETENTIONS_PATH,
  ROOT_PATH,
  UPLOAD_PATH,
} from "lib"
import { Forbidden, Login } from "pages"
import UploadRetentions from "pages/Retentions/UploadRetentions"
import React from "react"
import { Route } from "react-router-dom"

const Public = () => {
  return (
    <React.Fragment>
      <Route exact path={`${ROOT_PATH}`} component={Login} />
      <Route
        exact
        path={`${ERROR_PATH + FORBIDDEN_PATH}`}
        component={Forbidden}
      />
      <Route
        exact
        path={`${UPLOAD_PATH + RETENTIONS_PATH}`}
        component={UploadRetentions}
      />
    </React.Fragment>
  )
}

export default Public
